<script setup lang="ts">
import type { GenericImage } from '.';
import type { CarouselApi } from '@/components/ui/carousel';

import {
	Carousel,
	CarouselContent,
	CarouselItem,
	CarouselItemSelector
} from '@/components/ui/carousel';

interface Props {
	className?: string;
	images: GenericImage[];
	selectedIndex: number;
}

defineProps<Props>();

const emits = defineEmits<{
	(event: 'thumb-click', index: number): void;
	(event: 'init-api', api: CarouselApi): void;
}>();

const emitInitApi = (api: CarouselApi) => {
	emits('init-api', api);
};
</script>

<template>
	<Carousel :class="className" @init-api="emitInitApi">
		<CarouselContent>
			<CarouselItem
				v-for="(image, index) in images.length"
				:key="`selector-${index}`"
				class="mx-2 basis-14 cursor-pointer"
				@click="() => emits('thumb-click', index)"
			>
				<CarouselItemSelector
					:active="selectedIndex === index"
					:delay="0"
					variant="dark"
					size="sm"
				/>
			</CarouselItem>
		</CarouselContent>
	</Carousel>
</template>
